import { useEffect, useState } from "react";
import { apiGet } from "./api";
import type { Volunteer } from "../types/volunteer";

interface State {
  data: Volunteer[];
  loading: boolean;
  error: string | null;
}

export function useVolunteers(): State {
  const [state, setState] = useState<State>({ data: [], loading: true, error: null });

  useEffect(() => {
    let cancelled = false;
    apiGet<{ volunteers: Volunteer[] }>("/volunteers")
      .then((res) => {
        if (!cancelled) setState({ data: res.volunteers, loading: false, error: null });
      })
      .catch((err: Error) => {
        if (!cancelled) setState({ data: [], loading: false, error: err.message });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
